import { Component, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { Subscription } from 'rxjs/Subscription';
import { fuseAnimations } from '../../../../../../../../../../core/animations';

/**Local files */
import { displayValues, assignPro, spekwo } from '../../../../../../../utils/index';

/** Service file */
import { AssignProService } from '../../../../../../assignPro/assignPro.service';
import { SideNavService } from '../../../../sidenav.service';

@Component({
    selector: 'pro-lists',
    templateUrl: './proList.component.html',
    styleUrls: ['./proList.component.scss'],
    animations: fuseAnimations
})

export class ProListsComponent {

    displayValues = displayValues;
    assignPro = assignPro;
    spekwoValues = spekwo;

    displayedColumns = ['profile', 'name', 'email', 'phoneNumber', 'detail-button'];

    proUsers: UserData[] = [];

    dataSource: MatTableDataSource<UserData>;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) proSort: MatSort;

    proUsersSubscription: Subscription;
    onProInfoChangedSubscription: Subscription;
    onProInfoFilteredSubscription: Subscription;

    filesList = [];
    selected: any;
    isLoading: boolean = false;

    constructor(
        /** Service file */
        public assignProService: AssignProService,
        public sideNavService: SideNavService
    ) {
        this.sideNavService.onProInfoSelected.subscribe(selected => {
            this.selected = selected[1];
        });
    }

    ngOnInit() {

        /**     
        * Get all pro users  
        * */
        this.proUsersSubscription =
            this.assignProService.onAllProUsers.subscribe(response => {

                this.isLoading = true;

                if (!response.loading) {
                    this.isLoading = false;

                    this.proUsers = response.users;
                    this.dataSource = new MatTableDataSource(this.proUsers);
                    this.dataSource.paginator = this.paginator;
                    this.dataSource.sort = this.proSort;
                    /**
                    * Initially points first userId
                    */
                    if (this.proUsers.length > 0) {

                        var userId = response.users[0].userId;
                        var userName = response.users[0].firstName;
                        this.sideNavService.onProInfoSelected.next([this.filesList[userId], userId, userName]);

                    }
                    this.isLoading = false;
                }

            }, () => {
                this.isLoading = false;
            })

        /**
         * Get files documents 
         * */

        this.onProInfoChangedSubscription =
            this.sideNavService.onProInfoChanged.subscribe(files => {
                this.filesList = files.message;
            }, () => {
                console.log(' errors ');
            })

        /** Filter pro people */

        this.onProInfoFilteredSubscription =
            this.sideNavService.onProInfoFiltered.subscribe(filter => {

                filter = filter.trim(); // Remove whitespace
                filter = filter.toLowerCase(); // MatTableDataSource defaults to lowercase matches
                this.dataSource.filter = filter;
            })
    }

    ngOnDestroy() {
        this.proUsersSubscription.unsubscribe();
        this.onProInfoChangedSubscription.unsubscribe();
        this.onProInfoFilteredSubscription.unsubscribe();
    }

    setDefaultPic(event) {
        event.target.src = this.spekwoValues.defaultImg;
    }

    /** Based on row select- Change sidenav */
    onSelect(selected) {
        var userName = selected.firstName;
        this.sideNavService.onProInfoSelected.next([this.filesList[selected.userId], selected.userId, userName]);
    }

}
export interface UserData {
    photoUrl: string,
    name: string;
    email: string;
    phoneNumber: string;
    userId: string;
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/pros/review/pro-list/proList.component.ts